var map = {
	"./0001.mp3": "a4cc",
	"./0002.mp3": "2aec",
	"./0003.mp3": "77a2",
	"./0004.mp3": "076c",
	"./0005.mp3": "1b85",
	"./0006.mp3": "b763",
	"./0007.mp3": "f73b",
	"./0008.mp3": "aa6c",
	"./0009.mp3": "f276",
	"./0010.mp3": "d060",
	"./0011.mp3": "b196",
	"./0012.mp3": "0c10",
	"./0013.mp3": "a064",
	"./0014.mp3": "c450",
	"./ambient.mp3": "7dec",
	"./answer.mp3": "a4fe",
	"./answer_reverse.mp3": "3b7a",
	"./blip/1.wav": "c5a1",
	"./blip/2.wav": "dae4",
	"./blip/3.wav": "2ef4",
	"./blip/4.wav": "24de",
	"./blip/5.wav": "6102",
	"./chourlih.mp3": "08dd",
	"./chritah.mp3": "7ef0",
	"./kri.mp3": "a6ba",
	"./krovah.mp3": "3897",
	"./lorkah.mp3": "55af",
	"./orrlah.mp3": "fc83",
	"./rrah.mp3": "3265",
	"./soumdorh.mp3": "6f3d",
	"./tharki.mp3": "a8bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8594";